import { Component, OnInit, Input } from '@angular/core';
import { PqrService } from '../../service/pqr/pqr.service';
import { Pqr } from '../../class/pqr';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { AbstractControl, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, DataTable } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { GestionSAC } from '../../class/gestionSAC';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-pqrs',
  templateUrl: './pqrs.component.html',
  styleUrls: ['./pqrs.component.scss']
})
export class PqrsComponent implements OnInit {
    @Input() gestionSac: any;

    public promiseForm: Promise<any>;
    public msgs: Message[] = [];
    public pqr: Pqr[];
    public selectPqr: Pqr;
    public pqrID: Number = 0;
    public modNew = false;
    public modView = false;
    public openPqr = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;
    public pqrPosition: string;
    public filters: {key: string, value: string}[];

    public first = 0;

    public showFilter: boolean;

    public form3: FormGroup;

    public form4: FormGroup;

    public apiUrl = config.API_ROOT;

    public modExportDialog: boolean;

    public statusOptions: SelectItem[];
    public type_problemOptions: SelectItem[];
    public priorityOptions: SelectItem[];

    public pagePath: string;
    public subPagePath: string;

    public myEmployeeId: string;

    public verification: boolean;

    public params_id_pqr: number;

    public showNewPqr: boolean;

    public showExportPqr: boolean;

    public reloadInterval: any;

    public loading: boolean;

    public es: any;

    constructor(
        public pqrService: PqrService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,
        public hasPermissionService: HasPermissionService,
        private route: ActivatedRoute,
        public activatedRoute: ActivatedRoute,
        public fb: FormBuilder
    ) {
        this.loading = false;

        this.page = 1;
        this.per_page = 10;
        this.sort = '-id';

        this.es = calendarES();

        this.statusOptions = [
            {label: 'Todas', value: 'all'},
            {label: 'Abierta', value: 'Abierta'},
            {label: 'En Trámite', value: 'En Trámite'},
            {label: 'Solucionada', value: 'Solucionada'},
            // {label: 'Cerrada', value: 'Cerrada'},
            {label: 'Verificada', value: 'Verificada'},
        ];

        this.type_problemOptions = [
            {label: 'Todas', value: 'all'},
            {label: 'Queja', value: 'Queja'},
            {label: 'No Conforme', value: 'No Conforme'},
            {label: 'Solicitud', value: 'Solicitud'},
            {label: 'Felicitación', value: 'Felicitación'},
        ];

        this.priorityOptions = [
            {label: 'Todas', value: 'all'},
            {label: 'Alta', value: 'Alta'},
            {label: 'Media', value: 'Media'},
            {label: 'Baja', value: 'Baja'},
        ];

        this.modExportDialog = false;

        this.loading = false;
    }

    ngOnInit() {
        if (this.route.snapshot.url[0].path !== 'gestionSACs') {
            this.pagePath = this.route.snapshot.url[0].path;
            this.subPagePath = this.route.snapshot.url[1].path;
            this.showFilter = true;
        } else {
            this.pagePath = 'pqrs';
            this.subPagePath = 'pqrs_reported';
            this.showFilter = false;
        }

        this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

        this.filters = [];
        if (this.gestionSac) {
            this.filters.push({key: 'gestion_sac_id-in', value: this.gestionSac.id});
            this.showNewPqr = true;
            this.showExportPqr = false;
        } else {
            switch (this.pagePath) {
                case 'pqrs':
                    switch (this.subPagePath) {
                        case 'pqrs_reported':
                            this.filters.push({key: 'attended_by_id-in', value: this.myEmployeeId});
                            this.verification = false;
                            this.showNewPqr = true;
                            this.showExportPqr = false;
                        break;
                        case 'pqrs_asigned':
                            if (this.hasPermission('get pqr Desarrollo')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '42'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            }else if(this.hasPermission('get pqr Sistemas')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '1'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Gerencia')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '2'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Comercial')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '3'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Nómina')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '4'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Suministros')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '5'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Servicio al Cliente')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '6'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr HSE')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '7'});
                                //this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Contratación')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '8'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Contabilidad')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '9'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Selección')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '10'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Calidad')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '11'});
                                //this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Sercontratos')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '12'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '5'});
                            } else if (this.hasPermission('get pqr Gestión Humana')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '13'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Gestión de Pagos')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '14'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Medellín')) {
                                this.filters.push({'key': 'venue_id-lk', 'value': '4'});
                            } else if (this.hasPermission('get pqr Barranquilla')) {
                                this.filters.push({'key': 'venue_id-lk', 'value': '2'});
                            } else if (this.hasPermission('get pqr Cali')) {
                                this.filters.push({'key': 'venue_id-lk', 'value': '3'});
                            } else if (this.hasPermission('get pqr Bucaramanga')) {
                                this.filters.push({'key': 'venue_id-lk', 'value': '6'});
                            } else if (this.hasPermission('get pqr Buga')) {
                                this.filters.push({'key': 'venue_id-lk', 'value': '7'});
                            } else if (this.hasPermission('get pqr Jurídica')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '25'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            } else if (this.hasPermission('get pqr Seguridad Social')) {
                                this.filters.push({'key': 'department_id-lk', 'value': '45'});
                                this.filters.push({'key': 'venue_id-lk', 'value': '1'});
                            }
                            else {
                                this.filters.push({key: 'report_user_id-in', value: this.myEmployeeId});
                            }

                            this.verification = false;
                            this.showNewPqr = false;
                            this.showExportPqr = true;
                        break;
                        case 'pqrs_verification':
                            this.verification = true;
                            this.showNewPqr = false;
                            this.showExportPqr = true;
                        break;
                    }
                break;
            }
        }

        this.activatedRoute.queryParams.subscribe(params => {
            if (params['id_pqr']) {
                this.params_id_pqr = Number(params['id_pqr']);
                const filters = [];
                filters.push({key: 'id-in', value: String(this.params_id_pqr)});
                this.getPqrById(this.query, filters);
            } // else {
            //     this.getPqr();
            // }
        });

        this.reloadInterval = setInterval(() => {
            if (this.verification) {
                this.getPqr();
            }
        }, 500000);

        this.createForm3(null);

        this.createForm4(null);
    }

    public createForm3(data:any = null) {
      data = data || {
        status_filter: 'all',
        type_problem_filter: 'all',
        department_id_filter: '',
        priority_filter: 'all',
        company_id_filter: '',
        employee_id_filter: '',
      };
      this.form3 = this.fb.group({
        status_filter: new FormControl(data.status_filter),
        type_problem_filter: new FormControl(data.type_problem_filter),
        department_id_filter: new FormControl(data.department_id_filter),
        priority_filter: new FormControl(data.priority_filter),
        company_id_filter: new FormControl(data.company_id_filter),
        employee_id_filter: new FormControl(data.employee_id_filter),
      });
    }

    public createForm4(data:any = null) {
      data  = data || {
        f4_date_start: '',
        f4_date_end: '',
        f4_venue_id: '',
        f4_department_id: '',
        f4_status_filter: 'all',
      };
      this.form4 = this.fb.group({
        f4_date_start: new FormControl(data.f4_date_start, Validators.compose([Validators.required])),
        f4_date_end: new FormControl(data.f4_date_end, Validators.compose([Validators.required])),
        f4_venue_id: new FormControl(data.f4_venue_id),
        f4_department_id: new FormControl(data.f4_department_id),
        f4_status_filter: new FormControl(data.f4_status_filter),
      })
    }

    ngOnDestroy() {
        // Will clear when component is destroyed e.g. route is navigated away from.
        clearInterval(this.reloadInterval);
    }

    public loadPqrLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            if (event.sortField) {
                this.sort =  event.sortField;
            } else {
                this.sort = '-id';
            }
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        }
        this.getPqr();
    }

    getPqr() {
        this.loading = true;
        this.pqrService.getPqr(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
            response => {
                this.loading = false;
                this.pqr = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'Error al obtener las PQRSF' } );
            }
        );
    }

    public newPqr() {
        this.modNew = !this.modNew;
        this.selectPqr = null;
    }

    public savedPqr(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectPqr = null;
        this.modNew = false;
        // this.getPqr();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public cancelPqr (res) {
        this.selectPqr = null;
        this.modNew = false;
        this.modView = false;
        // this.getPqr();//Comentado porque existe componente y se quita y detecta load_lazy
    }

    public edit(pqr: Pqr) {
        this.modNew = true;
        this.selectPqr = pqr;
    }

    public view(pqr: Pqr) {
        this.openPqr = true;
        this.selectPqr = pqr;
        this.pqrID = pqr.id;
        this.modView = true;
    }

    public deleteDialog(pqr: Pqr) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(pqr);
            }
        });
    }

    public delete(pqr: Pqr) {
        this.pqrService.deletePqr(pqr.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'PQRSF borrada satisfactoriamente' } );
                this.getPqr();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'Error al borrar la PQRSF' } );
            }
        );
    }

    public activePqr(pqr: Pqr) {
        this.putPqr(pqr);
    }

    public putPqr(values: Pqr) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.pqrService.updatePqr(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error al actualizar la PQRSF' } );
                }
            );
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public hasRole(rol){
        var r: boolean=false;
        var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
        if(role == rol){
            r = true;
        }
        return (r);
    }

    public filter (values?) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (this.gestionSac) {
            this.filters.push({key: 'gestion_sac_id-in', value: this.gestionSac.id});
        }

        switch (this.pagePath) {
            case 'pqrs':
                switch (this.subPagePath) {
                    case 'pqrs_reported':
                        this.filters.push({key: 'attended_by_id-in', value: this.myEmployeeId});
                        this.verification = false;
                        this.showNewPqr = true;
                        this.showExportPqr = false;
                    break;
                    case 'pqrs_asigned':
                        if (this.hasPermission('get pqr Sistemas')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '1'});
                        } else if (this.hasPermission('get pqr Gerencia')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '2'});
                        } else if (this.hasPermission('get pqr Comercial')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '3'});
                        } else if (this.hasPermission('get pqr Nómina')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '4'});
                        } else if (this.hasPermission('get pqr Suministros')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '5'});
                        } else if (this.hasPermission('get pqr Servicio al Cliente')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '6'});
                        } else if (this.hasPermission('get pqr HSE')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '7'});
                        } else if (this.hasPermission('get pqr Contratación')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '8'});
                        } else if (this.hasPermission('get pqr Contabilidad')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '9'});
                        } else if (this.hasPermission('get pqr Selección')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '10'});
                        } else if (this.hasPermission('get pqr Calidad')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '11'});
                        } else if (this.hasPermission('get pqr Sercontratos')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '12'});
                        } else if (this.hasPermission('get pqr Gestión Humana')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '13'});
                        } else if (this.hasPermission('get pqr Gestión de Pagos')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '14'});
                        } else if (this.hasPermission('get pqr Contratación Medellín')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '15'});
                        } else if (this.hasPermission('get pqr Selección Medellín')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '16'});
                        } else if (this.hasPermission('get pqr Contratación Barranquilla')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '18'});
                        } else if (this.hasPermission('get pqr Selección Barranquilla')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '19'});
                        } else if (this.hasPermission('get pqr Contratación Cali')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '21'});
                        } else if (this.hasPermission('get pqr Selección Cali')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '22'});
                        } else if (this.hasPermission('get pqr Contratación Bucaramanga')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '23'});
                        } else if (this.hasPermission('get pqr Selección Bucaramanga')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '24'});
                        } else if (this.hasPermission('get pqr Jurídica')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '25'});
                        } else if (this.hasPermission('get pqr Seguridad Social')) {
                            this.filters.push({'key': 'department_id-lk', 'value': '45'});
                        }
                        else {
                            this.filters.push({key: 'report_user_id-in', value: this.myEmployeeId});
                        }

                        this.verification = false;
                        this.showNewPqr = false;
                        this.showExportPqr = true;
                    break;
                    case 'pqrs_verification':
                        this.verification = true;
                        this.showNewPqr = false;
                        this.showExportPqr = true;
                    break;
                }
            break;
        }

        if (values.status_filter !== 'all' && values.status_filter !== '') {
            this.filters.push({'key': 'status-lk', 'value': values.status_filter});
        }
        if (values.type_problem_filter !== 'all' && values.type_problem_filter !== ''){
            this.filters.push({'key': 'type_problem-lk', 'value': values.type_problem_filter});
        }
        if (values.department_id_filter) {
            this.filters.push({'key': 'department_id-lk', 'value': values.department_id_filter});
        }
        if (values.priority_filter !== 'all' && values.priority_filter !== '') {
            this.filters.push({'key': 'priority-lk', 'value': values.priority_filter});
        }
        if (values.company_id_filter) {
            this.filters.push({'key': 'company_id-lk', 'value': values.company_id_filter.id});
        }
        if (values.employee_id_filter) {
            this.filters.push({'key': 'report_user_id-lk', 'value': values.employee_id_filter.id});
        }
        this.getPqr();
    }

    getPqrById(query?: string, filters?: any[]) {
        this.loading = true;
        //this.modNew = false;
        this.pqrService.getPqr(this.page, this.per_page, this.sort, query, filters).toPromise().then(
            response => {
                this.loading = false;
                this.edit(response.json().data[0]);
            },
            error => {
                this.loading = false;
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'Error al obtener las PQRSF' } );
            }
        );
    }

    public showExportDialog() {
        this.modExportDialog = true;
    }

    public cancelExport() {
        this.modExportDialog = false;
    }

    public exportReportExcel(values) {
        let d = new Date(values.f4_date_start);
        d.setHours(0);
        d.setMinutes(0);
        d.setSeconds(0);
        d.setMilliseconds(0);

        const f4_date_start = formatDate(d);

        d = new Date(values.f4_date_end);
        d.setHours(23);
        d.setMinutes(59);
        d.setSeconds(59);
        d.setMilliseconds(59);
        const f4_date_end = formatDate(d);

        let url = this.apiUrl + '/pqrs/excel?' +
        'token=' + localStorage.getItem('token') +
        '&_page=1&_limit=100000&_sort=id&';

        if (f4_date_start) {
            url = url + 'created_at-min=' + f4_date_start + '&';
        }

        if (f4_date_end) {
            url = url + 'created_at-max=' + f4_date_end + '&';
        }

        if (values.f4_venue_id) {
            url = url + 'venue_id-in=' + values.f4_venue_id + '&';
        }
        if(this.verification)
        {
            if (values.f4_department_id) {
                url = url + 'department_id-in=' + values.f4_department_id + '&';
            }
        }
        else{
            var departmentId = JSON.parse(localStorage.getItem('profile')).employee.department_id;
            url = url + 'department_id-in=' + departmentId + '&';

        }
        if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
            url = url + 'status-in=' + values.f4_status_filter + '&';
        }

        window.open(url, '_blank');
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqrs/pqrs.component.ts